module.exports = __webpack_public_path__ + "static/03-2e38b23296dad8bfb84b7191e518cd2a.jpg";